import { gql } from '@apollo/client'

export const GET_FAVORITES_TERRITORIES_QUERY = gql`
  query getFavoritesTerritories {
    getWorkspace {
      id
      followedTerritories(pagination: { take: 5 }) {
        data {
          name
          territoryId

          ... on Subtopic {
            allParents {
              name
              territoryId
            }
          }

          ... on Niche {
            allParents {
              name
              territoryId
            }
          }
        }
      }
    }
  }
`
